import { render, staticRenderFns } from "./LayoutMain.vue?vue&type=template&id=4eb5ae16&scoped=true&"
import script from "./LayoutMain.vue?vue&type=script&lang=ts&"
export * from "./LayoutMain.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutMain.vue?vue&type=style&index=0&id=4eb5ae16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb5ae16",
  null
  
)

export default component.exports